import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Subscription } from 'rxjs';
import { InsuranceType } from 'src/app/_enums/insurance-type.enum';
import { formatDateForInput } from 'src/app/_helpers/utils';
import { TravelMetadata } from 'src/app/_types/lead.types';

import { LeadFormBase } from '../lead-form-base';

@Component({
  selector: 'app-lead-travel-form',
  templateUrl: './travel-form.component.html',
  styleUrls: ['./travel-form.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
})
export class TravelFormComponent
  extends LeadFormBase
  implements OnDestroy, OnInit
{
  @Input()
  formGroup!: FormGroup;

  adultsCountSubscription!: Subscription;

  childrenCountSubscription!: Subscription;

  private _startDate!: string;

  get startDate(): string {
    return this._startDate;
  }

  set startDate(value: string) {
    this._startDate = value;
    if (value)
      this.metadataFormGroup.controls['startDate'].setValue(
        new Date(value).toLocaleDateString('fr-FR')
      );
  }

  constructor(private fb: FormBuilder) {
    super();
  }

  metadataFormGroup: FormGroup = this.fb.group({
    type: this.fb.control(InsuranceType.TRAVEL),
    startDate: this.fb.control(null),
    adultsCount: this.fb.control(null),
    childrenCount: this.fb.control(null),
    isFamilyInsurance: this.fb.control(null),
  });

  override ngOnInit(): void {
    super.ngOnInit();
    this.formGroup.removeControl('metadata');
    if (this.metadata) {
      const travelMetadata = this.metadata as TravelMetadata;
      this.metadataFormGroup.patchValue(travelMetadata);
      this.startDate = formatDateForInput(travelMetadata.startDate);
    }
    this.formGroup.addControl('metadata', this.metadataFormGroup);
    this.adultsCountSubscription = this.metadataFormGroup.controls[
      'adultsCount'
    ].valueChanges.subscribe((value) => {
      this.metadataFormGroup.controls['isFamilyInsurance'].setValue(
        value + (this.metadataFormGroup.controls['childrenCount'].value ?? 0) >
          1
      );
    });
    this.childrenCountSubscription = this.metadataFormGroup.controls[
      'childrenCount'
    ].valueChanges.subscribe((value) => {
      this.metadataFormGroup.controls['isFamilyInsurance'].setValue(
        value + (this.metadataFormGroup.controls['adultsCount'].value ?? 0) > 1
      );
    });
  }

  ngOnDestroy(): void {
    this.childrenCountSubscription.unsubscribe();
    this.adultsCountSubscription.unsubscribe();
  }
}
